const RECENT_COMMENTS_LIMIT = 3;
const RECENT_REPLIES_PER_THREAD_LIMIT = 2;

export const trimToRecentThreads = (allComments) => {
  if (!Array.isArray(allComments) || allComments.length === 0) {
    return [];
  }

  const toTime = (value) => {
    const timestamp = value ? new Date(value).getTime() : 0;
    return Number.isFinite(timestamp) ? timestamp : 0;
  };

  const repliesByParent = allComments.reduce((acc, comment) => {
    if (comment?.parentId != null) {
      const parentId = String(comment.parentId);
      if (!acc[parentId]) {
        acc[parentId] = [];
      }
      acc[parentId].push(comment);
    }
    return acc;
  }, {});

  const latestThreadActivity = (comment) => {
    const rootId = comment?.id != null ? String(comment.id) : null;
    const replies = rootId ? repliesByParent[rootId] || [] : [];
    return replies.reduce(
      (latest, reply) => Math.max(latest, toTime(reply?.createdAt)),
      toTime(comment?.createdAt)
    );
  };

  const recentTopLevelIds = new Set(
    allComments
      .filter((comment) => comment && comment.parentId == null && comment.id != null)
      .sort((a, b) => latestThreadActivity(b) - latestThreadActivity(a))
      .slice(0, RECENT_COMMENTS_LIMIT)
      .map((comment) => String(comment.id))
  );

  const selectedComments = [];
  allComments.forEach((comment) => {
    if (!comment || comment.parentId != null || comment.id == null || !recentTopLevelIds.has(String(comment.id))) {
      return;
    }
    selectedComments.push(comment);
    (repliesByParent[String(comment.id)] || [])
      .slice()
      .sort((a, b) => toTime(b?.createdAt) - toTime(a?.createdAt))
      .slice(0, RECENT_REPLIES_PER_THREAD_LIMIT)
      .forEach((reply) => selectedComments.push(reply));
  });

  return selectedComments
    .sort((a, b) => toTime(a.createdAt) - toTime(b.createdAt));
};
